import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import { initStateMemberData } from "mocks/memberData";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../redux/store/configureStore";
import { base64ToBlob } from "utils/HelperFunction";
import { allowedFields, jsonKeys, loadDocDataFromDoProcess, mappingInvoice, mapProductToRequestItem, mapProductToRequestUpdateItem } from "utils/HelperInvoiceFunction";
import * as yup from "yup";
import { useNavigate, useParams } from "react-router-dom";
import { getHQAddressByDate } from "../../redux/handlers/logic/getHQAddressByDate.handler";
import { nanoid } from "@reduxjs/toolkit";
import { getNewInvoiceById } from "../../redux/slices/logic/getNewInvoiceById.slice";
import { useGlobalDocModalContext } from "contexts/GlobalDocModalContext";
import { isShowBranch, mappingSearchMember } from "utils/HelperMemberFunction";
import { clearUpdateNewInvoice, updateNewInvoice } from "../../redux/slices/logic/updateNewInvoice.slice";
import { clearCreateNewInvoice, createNewInvoice } from "../../redux/slices/logic/createNewInvoice.slice";
import { getNewDoById } from "../../redux/slices/logic/getNewDoById.slice";
import moment from "moment";
import { initStateInvoiceData } from "mocks/invoiceData";
import { clearGenReceiptByInvoiceId, genReceiptByInvoiceId } from "../../redux/slices/logic/genReceiptByInvoiceId.slice";
import { useInvoiceInitContext } from "contexts/invoicePage/InvoiceInitContext";
import { setMappedInvPaymentToFormik } from "utils/HelperInvoicePayment";
import { clearUpdateInvPaymentList, updateInvPaymentList } from "../../redux/slices/logic/updateInvPaymentList.slice";
import { useGlobalLoaderContext } from "contexts/GlobalLoaderContext";
export default function useInvoiceForm() {
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var setModalNotiDocAlert = useGlobalDocModalContext().setModalNotiDocAlert;
    var _useInvoiceInitContext = useInvoiceInitContext(), formdata = _useInvoiceInitContext.formdata, setFormdata = _useInvoiceInitContext.setFormdata, modalInvoiceModalState = _useInvoiceInitContext.modalInvoiceModalState;
    var _useParams = useParams(), invoiceID = _useParams.invoiceID, doID = _useParams.doID;
    var _useState = _sliced_to_array(useState(false), 2), genReceipt = _useState[0], setGenReceipt = _useState[1];
    var _useState1 = _sliced_to_array(useState(false), 2), updateInvPaymentListSubmit = _useState1[0], setUpdateInvPaymentListSubmit = _useState1[1];
    var _useState2 = _sliced_to_array(useState([]), 2), productRow = _useState2[0], setProductRow = _useState2[1];
    var _useState3 = _sliced_to_array(useState([]), 2), updateDocIds = _useState3[0], setUpdateDocIds = _useState3[1];
    var _useState4 = _sliced_to_array(useState({
        columnsort: [
            {
                id: "",
                sortKey: ""
            },
            {
                id: "",
                sortKey: ""
            },
            {
                id: "",
                sortKey: ""
            }
        ],
        type: "select"
    }), 2), columnsort = _useState4[0], setColumnsort = _useState4[1];
    var _useState5 = _sliced_to_array(useState(1), 2), tab = _useState5[0], setTab = _useState5[1];
    var _useState6 = _sliced_to_array(useState([]), 2), tagselected = _useState6[0], setTagSelected = _useState6[1];
    var _useState7 = _sliced_to_array(useState([]), 2), attachments = _useState7[0], setAttachments = _useState7[1];
    var modalNotApprove = modalInvoiceModalState.modalNotApprove, setModalSuccess = modalInvoiceModalState.setModalSuccess, setModalNotApprove = modalInvoiceModalState.setModalNotApprove, setModalConfirmCancel = modalInvoiceModalState.setModalConfirmCancel, setModalSubmitted = modalInvoiceModalState.setModalSubmitted;
    var schema = yup.object().shape({
        doc_issue_date: yup.string().required(),
        doc_due_date: yup.string().required("ต้องระบุวันที่ครบกำหนด").test("doc_due_date_after_issue", "วันที่ครบกำหนดต้องไม่น้อยกว่าวันที่ออกเอกสาร", function(value) {
            var doc_issue_date = this.parent.doc_issue_date;
            if (!value || !doc_issue_date) return true; // ปล่อยให้ required เช็คเอง
            return moment(value).isSameOrAfter(moment(doc_issue_date), "day");
        }),
        dim_mst_price_category_id: yup.string().required(),
        fact_member_id: yup.string().required(),
        dim_mst_payment_type_id: yup.string().required(),
        dim_branch_id: yup.string().required(),
        member_address: yup.string().required("กรุณาเพิ่มที่อยู่ก่อน"),
        not_approve_reason: yup.string().when([], {
            is: function() {
                return modalNotApprove.open;
            },
            then: function(schema) {
                return schema.required();
            }
        }),
        factNewInvPayment: yup.array().of(yup.object({
            factNewInvAdjustmentOrFee: yup.array().of(yup.object({
                dim_mst_adjust_or_fee_id: yup.string().required("จำเป็นต้องเลือกประเภทค่าปรับ/ค่าธรรมเนียม")
            })),
            factNewInvPaymentRow: yup.array().of(yup.object({
                dim_branch_payment_channel_id: yup.string().required("จำเป็นต้องเลือกประเภทค่าปรับ/ค่าธรรมเนียม")
            }))
        })).default([])
    });
    // Reducers
    var reducers = {
        createNewInvoice: useAppSelector(function(state) {
            return state.createNewInvoiceReducer;
        }),
        updateNewInvoice: useAppSelector(function(state) {
            return state.updateNewInvoiceReducer;
        }),
        getNewInvoiceById: useAppSelector(function(state) {
            return state.getNewInvoiceByIdReducer;
        }),
        getNewDoById: useAppSelector(function(state) {
            return state.getNewDoByIdReducer;
        }),
        genReceiptByInvoiceId: useAppSelector(function(state) {
            return state.genReceiptByInvoiceIdReducer;
        }),
        updateInvPaymentList: useAppSelector(function(state) {
            return state.updateInvPaymentListReducer;
        })
    };
    var isFormInvoiceLoading = useMemo(function() {
        return reducers.createNewInvoice.isFetching || reducers.updateNewInvoice.isFetching || reducers.getNewInvoiceById.isFetching || reducers.getNewDoById.isFetching || reducers.genReceiptByInvoiceId.isFetching || reducers.updateInvPaymentList.isFetching;
    }, [
        reducers.createNewInvoice.isFetching,
        reducers.updateNewInvoice.isFetching,
        reducers.getNewInvoiceById.isFetching,
        reducers.getNewDoById.isFetching,
        reducers.genReceiptByInvoiceId.isFetching,
        reducers.updateInvPaymentList.isFetching
    ]);
    var _useState8 = _sliced_to_array(useState(false), 2), formdisabled = _useState8[0], setFormdisabled = _useState8[1];
    var _useState9 = _sliced_to_array(useState(initStateMemberData), 2), pdata = _useState9[0], setPdata = _useState9[1];
    var _useState10 = _sliced_to_array(useState("สร้างใบแจ้งหนี้"), 2), headerName = _useState10[0], setheaderName = _useState10[1];
    var formatResult = function(item) {
        var mappingMember = mappingSearchMember(item);
        var isShowBranchMember = isShowBranch({
            custType: item.member_customer_type,
            isHQ: item.member_is_hq,
            branchNo: item.member_branch_no
        });
        return /*#__PURE__*/ _jsxs("div", {
            className: "",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    children: [
                        mappingMember.customerName,
                        isShowBranchMember ? " - (".concat(mappingMember.branchCode, ")") : ""
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "tc-5",
                    children: [
                        mappingMember.customerID ? mappingMember.customerID : "ไม่พบเลขผู้เสียภาษี",
                        " ",
                        "- ",
                        mappingMember.customerCode
                    ]
                })
            ]
        }, nanoid());
    };
    var getHQAddress = function(payload) {
        dispatch(getHQAddressByDate(payload, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    };
    var getData = function() {
        var id = invoiceID;
        dispatch(getNewInvoiceById({
            id: id,
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    };
    var getDoData = function() {
        var id = doID;
        dispatch(getNewDoById({
            id: id,
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    };
    var handleMainSubmit = function(param) {
        var values = param.values;
        // console.log("handleMainSubmit", values);
        var keysToInclude = [];
        if (updateInvPaymentListSubmit === true) {
            keysToInclude = [
                "fact_new_inv_payments"
            ];
        } else {
            keysToInclude = allowedFields;
        }
        var formdataPayload = new FormData();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                var value = values[key];
                if (value === undefined || value === null) return "continue";
                if (key === "doc_files" && Array.isArray(value)) {
                    value.forEach(function(file) {
                        if (file.docData) {
                            var blob = base64ToBlob(file.docData);
                            formdataPayload.append(key, blob, "".concat(file.docName));
                        }
                    });
                } else if (jsonKeys.includes(key)) {
                    formdataPayload.append(key, JSON.stringify(value));
                } else if (Array.isArray(value)) {
                    value.forEach(function(item) {
                        formdataPayload.append(key, item);
                    });
                } else {
                    formdataPayload.append(key, value);
                }
            };
            for(var _iterator = keysToInclude[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        // console.log(formdataPayload);
        var id = invoiceID;
        var payload = formdataPayload;
        if (genReceipt === true) {
            dispatch(genReceiptByInvoiceId({
                id: id,
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
        } else if (updateInvPaymentListSubmit === true) {
            dispatch(updateInvPaymentList({
                id: id,
                payload: payload,
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
        } else if (!invoiceID) {
            dispatch(createNewInvoice({
                payload: payload,
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
        } else {
            dispatch(updateNewInvoice({
                id: id,
                payload: payload,
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
        }
    };
    var handlePreSubmit = function(param) {
        var productRow = param.productRow, setFieldValue = param.setFieldValue, handleSubmit = param.handleSubmit, values = param.values, attachments = param.attachments, tagselected = param.tagselected, updateDocIds = param.updateDocIds, setModalAlert = param.setModalAlert, setErrors = param.setErrors;
        var product = productRow.filter(function(prev) {
            return prev.productCode !== "";
        });
        if (product && product.length > 0) {
            var newItems = [];
            var AFTER_APPROVE = [
                2,
                3,
                5,
                6
            ];
            if (AFTER_APPROVE.includes(values.dim_mst_invoice_status_id) && invoiceID) {
                newItems = mapProductToRequestUpdateItem(product);
            } else {
                newItems = mapProductToRequestItem(product);
            }
            schema.validate(_object_spread_props(_object_spread({}, values), {
                fact_new_invoice_items: newItems,
                attachments: attachments,
                tagselected: tagselected
            }), {
                abortEarly: false
            }).then(function() {
                setFieldValue("doc_files", _to_consumable_array(attachments.map(function(v) {
                    return {
                        docData: v.docFileData,
                        docName: v.docFile
                    };
                })));
                var itemField = AFTER_APPROVE.includes(values.dim_mst_invoice_status_id) && invoiceID ? "update_invoice_items" : "fact_new_invoice_items";
                setFieldValue(itemField, newItems);
                setFieldValue("tag_invoices", tagselected);
                setMappedInvPaymentToFormik({
                    values: values,
                    setFieldValue: setFieldValue
                });
                if (invoiceID) {
                    setFieldValue("update_doc_ids", updateDocIds);
                }
                handleSubmit();
            }).catch(function(err) {
                var _err_errors;
                var errorMessage = ((_err_errors = err.errors) === null || _err_errors === void 0 ? void 0 : _err_errors.join("\n")) || "Invalid data. Please check the form.";
                console.log(errorMessage);
                var formErrors = {};
                err.inner.forEach(function(e) {
                    if (e.path) formErrors[e.path] = e.message;
                });
                setErrors(formErrors);
            });
        } else {
            setModalAlert(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    open: true
                });
            });
        }
    };
    useEffect(function() {
        if (reducers.createNewInvoice.data && !reducers.createNewInvoice.isError) {
            setModalSuccess(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    open: true
                });
            });
            // setFormdisabled(true);
            dispatch(clearCreateNewInvoice());
            var createdData = reducers.createNewInvoice.data.data;
            var id = createdData && createdData.id ? createdData.id : null;
            if (id) {
                setModalNotiDocAlert(function(prev) {
                    return _object_spread_props(_object_spread({}, prev), {
                        open: prev.extra.genDocNumber !== createdData.doc_number,
                        extra: {
                            genDocNumber: prev.extra.genDocNumber,
                            createdDocNumber: createdData.doc_number
                        }
                    });
                });
                navigate("/sale/invoice/edit/".concat(id));
            } else {
                navigate("/sale/invoice");
            }
        }
        var isUpdateNewInvoiceSuccess = reducers.updateNewInvoice.data && !reducers.updateNewInvoice.isError;
        var isGenReceiptByInvoiceIdSuccess = reducers.genReceiptByInvoiceId.data && !reducers.genReceiptByInvoiceId.isError;
        var isUpdateInvPaymentListSuccess = reducers.updateInvPaymentList.data && !reducers.updateInvPaymentList.isError;
        var isReadyToGetData = isUpdateNewInvoiceSuccess || isGenReceiptByInvoiceIdSuccess || isUpdateInvPaymentListSuccess;
        if (isReadyToGetData) {
            if (isUpdateNewInvoiceSuccess) {
                dispatch(clearUpdateNewInvoice());
            }
            if (isGenReceiptByInvoiceIdSuccess) {
                dispatch(clearGenReceiptByInvoiceId());
            }
            if (isUpdateInvPaymentListSuccess) {
                dispatch(clearUpdateInvPaymentList());
            }
            setModalNotApprove(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    open: false
                });
            });
            setModalConfirmCancel(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    open: false
                });
            });
            setModalSubmitted(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    open: false
                });
            });
            setModalSuccess(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    open: true
                });
            });
            setGenReceipt(false);
            setUpdateInvPaymentListSubmit(false);
            setTab(1);
            getData();
        }
        if (reducers.getNewInvoiceById.data && !reducers.getNewInvoiceById.isError && invoiceID) {
            var invoiceData = reducers.getNewInvoiceById.data.data;
            if (!invoiceData) {
                return navigate("/404", {
                    replace: true
                });
            }
            var dataWithReplacements = mappingInvoice({
                invoiceData: invoiceData,
                setPdata: setPdata,
                setProductRow: setProductRow,
                setFormdisabled: setFormdisabled,
                columnsort: columnsort,
                setColumnsort: setColumnsort,
                setAttachments: setAttachments,
                setTagSelected: setTagSelected
            });
            var endDate = dataWithReplacements.doc_issue_date;
            getHQAddress({
                end_date: endDate
            });
            setFormdata(dataWithReplacements);
        }
        if (reducers.getNewDoById.data && !reducers.getNewDoById.isError && doID) {
            var doData = reducers.getNewDoById.data.data;
            if (!doData) {
                return navigate("/404", {
                    replace: true
                });
            }
            var docSelected = doData;
            loadDocDataFromDoProcess({
                docSelected: docSelected,
                setProductRow: setProductRow,
                setFormdata: setFormdata,
                setPdata: setPdata
            });
        }
    }, [
        reducers.createNewInvoice.data,
        reducers.updateNewInvoice.data,
        reducers.getNewInvoiceById.data,
        reducers.getNewDoById.data,
        reducers.genReceiptByInvoiceId.data,
        reducers.updateInvPaymentList.data
    ]);
    useEffect(function() {
        if (doID) {
            getDoData();
        }
        if (invoiceID) {
            getData();
            setheaderName("แก้ไขใบแจ้งหนี้");
        } else {
            setFormdata(initStateInvoiceData);
        }
    }, [
        invoiceID,
        doID
    ]);
    useEffect(function() {
        if (invoiceID && (formdata === null || formdata === void 0 ? void 0 : formdata.factDocFileInvoice)) {
            var deleteCandidateDocIds = formdata.factDocFileInvoice.map(function(item) {
                return item.id;
            });
            var deleteDocIds = deleteCandidateDocIds.filter(function(docId) {
                return !attachments.some(function(doc) {
                    return doc.docId === docId;
                });
            });
            setUpdateDocIds(deleteDocIds);
        }
    }, [
        formdata,
        attachments
    ]);
    return {
        schema: schema,
        formdisabled: formdisabled,
        setFormdisabled: setFormdisabled,
        formdata: formdata,
        setFormdata: setFormdata,
        pdata: pdata,
        setPdata: setPdata,
        formatResult: formatResult,
        handleMainSubmit: handleMainSubmit,
        handlePreSubmit: handlePreSubmit,
        headerName: headerName,
        isFormInvoiceLoading: isFormInvoiceLoading,
        genReceipt: genReceipt,
        setGenReceipt: setGenReceipt,
        tab: tab,
        setTab: setTab,
        productRow: productRow,
        setProductRow: setProductRow,
        columnsort: columnsort,
        setColumnsort: setColumnsort,
        attachments: attachments,
        setAttachments: setAttachments,
        tagselected: tagselected,
        setTagSelected: setTagSelected,
        updateDocIds: updateDocIds,
        setUpdateDocIds: setUpdateDocIds,
        modalInvoiceModalState: modalInvoiceModalState,
        updateInvPaymentListSubmit: updateInvPaymentListSubmit,
        setUpdateInvPaymentListSubmit: setUpdateInvPaymentListSubmit
    };
}
